<template>
  <el-dialog
    title="提示"
    :visible.sync="openFileUploadingDialog"
    width="30%"
    :before-close="closeDialog">
    <span>这是一段信息</span>
    <span slot="footer" class="dialog-footer">
    <el-button @click="closeDialog">取 消</el-button>
    <el-button type="primary" @click="closeDialog">确 定</el-button>
  </span>
  </el-dialog>
</template>

<script>
import {mapState, mapMutations} from 'vuex'
export default {
  props: ['dialogVisible'],
  data () {
    return {
    }
  },
  methods: {
    ...mapMutations(['setOpenFileUploadingDialog']),
    closeDialog () {
      this.setOpenFileUploadingDialog(false)
    }
  },
  computed: {
    ...mapState(['openFileUploadingDialog'])
  }
}
</script>



// WEBPACK FOOTER //
// src/components/dialog/FileUploading.vue